import { ItemCollection } from '@kistill/client/data-access'
import {
  HeaderTableCell,
  TableItemCell,
  IconRouteButton,
} from '@kistill/client/shared/ui'
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { useNavigate } from 'react-router-dom'

interface ItemCollectionContentProps {
  data: ItemCollection[]
}

export function RecentCollections({ data }: ItemCollectionContentProps) {
  const navigate = useNavigate()

  const handleRowDoubleClick = (guid: string) => {
    navigate(`/adfang/${guid}`)
  }

  return (
    <>
      <Typography component='h2' variant='h4' sx={{ mt: 4, mb: 1 }}>
        Aðföng
      </Typography>
      <TableContainer>
        <Table aria-label='item collection table'>
          <TableHead>
            <TableRow>
              <HeaderTableCell>Uppruni</HeaderTableCell>
              <HeaderTableCell>Aðfang</HeaderTableCell>
              <HeaderTableCell>Heiti</HeaderTableCell>
              <HeaderTableCell> </HeaderTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data &&
              data &&
              data.map((row, index) => (
                <TableRow
                  key={`itemCollection-${-index}`}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                  }}
                  onDoubleClick={() => handleRowDoubleClick(row.guid)}
                  hover={true}
                >
                  <TableItemCell>{row.originNumber}</TableItemCell>
                  <TableItemCell>{row.itemCollectionNumber}</TableItemCell>
                  <TableItemCell>
                    {row.itemCollectionJsonResponse.heiti}
                  </TableItemCell>

                  <TableItemCell sx={{ p: 1, width: 10 }}>
                    <IconRouteButton
                      to={`/adfang/${row.guid}`}
                      tooltipText='Breyta'
                    >
                      <EditIcon fontSize='small' />
                    </IconRouteButton>
                  </TableItemCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
